import React, { Component } from 'react';

import { ArrayUtils, StringUtils } from '../utils';
import { History as history, Routes as routes } from '../navigation';
import { Header, Line } from '../components';
import '../css/SignIn.css';

class PracticeEnterpriseMessage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      invites: [],
    }
  }

  componentDidMount() {

  }

  renderEnterpriseMessage = () => {
    let practice = this.props.practice;

    if (!practice) {
      return null;
    }

    let subscription       = practice.subscription || {};
    let is_enterprise      = subscription && subscription.subscription_type  && subscription.subscription_type  === 'ENTERPRISE' ? true : false;
    let subscription_type  = subscription && subscription.subscription_type  ?  subscription.subscription_type  : '';
    let enterprise         = practice.enterprise   || null;
    let default_enterprise = subscription && subscription.default_enterprise && subscription.default_enterprise === true ? true : false;

    let enterprise_message = '';

    if (enterprise && !is_enterprise) {
      if(!enterprise.content.contacted) {

        if(subscription_type === 'INSTANT' && default_enterprise) {
          enterprise_message = "As we're creating your enterprise subscription, feel free to use our free features";
        } else {
          enterprise_message = "You have chosen to upgrade your subscription to Enterprise. We will be in contact to upgrade your subscription.";
        }

      }
    }

    if (!enterprise_message) {
      return null;
    }

    return <div className="standard-container">
      <Header title='Enterprise Request Received'
              icon='fas fa-crown'
              button_title='Edit Contact Information'
              button_action={ () => {
                this.props.practiceActions.openSubscriptionDetails();
              }}
            />
      <div style={{ padding: 15 }}>
        <span style={{ color: 'grey', fontSize: 13 }}>{ enterprise_message }</span>
      </div>
    </div>
  }

  render() {
    return this.renderEnterpriseMessage();
  }

}

export default PracticeEnterpriseMessage
